import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useConsultarFatura } from "../../../hooks/queries/pagamento/useConsultarFatura/useConsultarFatura";
import { DEFAULT_PAGE_SIZE } from "../../../constants/pagination";
import { IFaturaDTO } from "../../../types/pagamento";

export const useInvoicesScheduleV2 = () => {
  const [searchParams] = useSearchParams();
  const uuidAgendamento = searchParams.get("id") || "";
  const [numberPage, setNumberPage] = useState(0);
  const navigate = useNavigate();

  const { data } = useConsultarFatura(
    uuidAgendamento,
    numberPage,
    DEFAULT_PAGE_SIZE,
  );

  const faturas = data?.content ?? [];
  const pagination = {
    actualPage: data?.number ?? 0,
    totalPage: data?.totalPages ?? 0,
    totalRegister: data?.totalElements ?? 0,
  };

  function acessarFatura(fatura: IFaturaDTO) {
    fatura?.pix?.qrcodeText !== null
      ? navigate(`/agendamento/${uuidAgendamento}/fatura`)
      : window.open(`${fatura?.url}.pdf`, "_blank");
  }

  return { faturas, pagination, numberPage, setNumberPage, acessarFatura };
};
